<template>
  <div class="p-workbench">
    <a-spin tip="加载中..." :spinning="loading">
      <workbench-header :go-to-personal-center="goToPersonalCenter" @refresh-list="refreshList" />
      <div class="p-workbench-warp">
        <div class="p-workbench-left">
          <template v-if="productList.length || packageList.length">
            <product-list v-if="productList.length > 0" @click-item="gotoDetail" />
            <micro-application @click-item="gotoDetail" />
            <scheme-card v-if="packageList.length > 0" @click-item="gotoDetail" />
          </template>
          <template v-else>
            <micro-application @click-item="gotoDetail" />
            <station-card type="task" wide @to-list="gotoStationPage('task')" />
            <station-card type="notice" wide @to-list="gotoStationPage('notice')" />
          </template>
        </div>
        <div class="p-workbench-right">
          <user-card :go-to-personal-center="goToPersonalCenter" />
          <worklog-card v-if="isStaff" :go-to-personal-center="goToPersonalCenter" />
          <template v-if="productList.length || packageList.length">
            <station-card type="task" @to-list="gotoStationPage('task')" />
            <station-card type="notice" @to-list="gotoStationPage('notice')" />
          </template>
          <template v-else>
            <quick-access :go-to-personal-center="goToPersonalCenter" />
          </template>
        </div>
        <!-- 小链客服 -->
        <div class="p-my-product__root">
          <img class="p-my-product__root__img" src="@/assets/images/product/root.png" />
          <div class="p-my-product__root__body">
            <div class="p-my-product__root__code">
              <img src="@/assets/images/product/more-code.png" />
            </div>
          </div>
        </div>
      </div>
      <welcome v-show="showWelcome" :app-name="welcomeAppName" />
    </a-spin>
  </div>
</template>

<script>
import $utils from '../../utils/utils'
import WorkbenchHeader from './components/workbench-header'
import MicroApplication from './components/micro-application.vue'
import ProductList from './components/product-list.vue'
import SchemeCard from './components/scheme-card.vue'
import StationCard from './components/station-card.vue'
import UserCard from './components/user-card.vue'
import WorklogCard from './components/worklog-card.vue'
import QuickAccess from './components/quick-access.vue'
import Welcome from '@/components/welcome.vue'
import { checkLogin, getAppInfoByCode } from '../../api/user-api.js'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    WorkbenchHeader,
    UserCard,
    WorklogCard,
    StationCard,
    ProductList,
    MicroApplication,
    SchemeCard,
    QuickAccess,
    Welcome
  },
  data() {
    return {
      // 微应用
      miniappList: [],
      // 我的产品
      productList: [],
      packageList: [],
      interval: '',
      welcomeAppName: '',
      showWelcome: false,
      loading: true
    }
  },
  computed: {
    ...mapState({
      appInfo: state => state.product.appInfo,
      staffInfo: state => state['user-info'].staffInfo
    }),
    isStaff() {
      return this.staffInfo && this.staffInfo.status === 1
    }
  },
  watch: {
    appInfo: {
      handler() {
        this.setAppInfo()
        if (Object.keys(this.appInfo).length) {
          this.loading = false
        }
      },
      immediate: true
    },
    staffInfo: {
      handler() {
        if (Object.keys(this.staffInfo).length) {
          this.loading = false
        }
      },
      immediate: true
    }
  },
  created() {
    sessionStorage.removeItem('mobile-login-refresh')
    sessionStorage.removeItem('mobile-welcome-refresh')
    if ($utils.isMobile() && !sessionStorage.getItem('mobile-product-refresh')) {
      sessionStorage.setItem('mobile-product-refresh', '1')
      window.location.reload()
      return
    }
    try {
      this.breathe()
    } catch {}
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions('system-monitoring', ['isLive']),
    breathe() {
      this.isLive()
      this.interval = setInterval(() => {
        this.isLive()
      }, 60000)
    },
    async refreshList() {
      await this.$store.dispatch('product/getAppInfo')
    },
    setAppInfo() {
      const appList = this.appInfo.standard || []

      this.productList = appList || []
      this.packageList = this.appInfo.service_package || []
      this.miniappList = this.appInfo.miniapp || []
    },
    gotoStationPage(stationType) {
      this.goToPersonalCenter(`/personal-center/message.html?type=${stationType}`)
    },
    async goToPersonalCenter(enterPath) {
      await this.gotoAppByAppCode('personal-center', enterPath)
    },
    async gotoAppByAppCode(appCode, enterPath) {
      try {
        const appInfo = await getAppInfoByCode({ appCode })
        if (appInfo) {
          sessionStorage.setItem('enterPath', enterPath || '')
          if ($utils.isMobile()) {
            this.gotoAppPageInMobile(appInfo.appId)
          } else {
            this.$toPage('/welcome', {
              pucAppId: appInfo.appId,
            })
          }
        }
      } catch (error) {
        this.$message.error('暂无权限，请联系管理员')
      }
    },
    async gotoDetail(item, enterPath) {
      if (enterPath) {
        sessionStorage.setItem('enterPath', enterPath || '')
      }
      if ($utils.isMobile()) {
        this.gotoAppPageInMobile(item.appId)
      } else {
        this.$toPage('/welcome', {
          pucAppId: item.appId
        })
      }
    },
    async gotoAppPageInMobile(pucAppId) {
      const loginResult = await checkLogin({
        appId: pucAppId
      })
      if (!loginResult.accessible) {
        this.$message.warning(loginResult.message)
        return
      }
      let url = loginResult.appHomePage
      if (sessionStorage.getItem('enterPath')) {
        url = sessionStorage.getItem('enterPath')
      }
      sessionStorage.removeItem('enterPath')
      const appInfo = loginResult.app || {}
      this.showWelcome = true
      this.welcomeAppName = appInfo.name
      if ($utils.isMobile()) {
        document.body.style.overflow = 'hidden'
        if (window.orientation === 180 || window.orientation === 0) {
          $utils.setRem(true)
        }
        document.querySelector('html').style.overflow = 'hidden'
      }
      // 接口返回的数据，跳转的url需要加上参数
      if (appInfo.appId) {
        const token = localStorage.getItem('token')
        const sessionId = sessionStorage.getItem('sessionId') || ''
        const code = appInfo.code || ''
        const adminUrl = process.env.VUE_APP_ADMIN_URL
        if (/.*\.html\?.*/.test(url)) {
          url = `${adminUrl}${url}&pucAppId=${pucAppId}&token=${token}&sessionId=${sessionId}`
        } else {
          url = `${adminUrl}${url}?code=${code}&pucAppId=${pucAppId}&token=${token}&sessionId=${sessionId}`
        }
      }
      setTimeout(() => {
        sessionStorage.removeItem('mobile-product-refresh')
        window.location.href = url
      }, 1000)
    },
  }
}
</script>

<style lang="scss">
.p-workbench {
  min-width: 1440px;
  height: auto !important;
  .p-workbench-warp {
    height: calc(100% - 0.64rem);
    min-height: calc(100vh - 0.64rem);
    background-color: rgba(240, 242, 245, 1);
    padding: 0.26rem;
    display: flex;
    justify-content: space-between;
    .p-workbench-left {
      flex: 1;
      min-width: 850px;
      .c-micro-application, .c-scheme-card {
        margin-top: 0.26rem;
      }
    }
    .p-workbench-right {
      width: 510px;
      min-width: 400px;
      margin-left: 0.26rem;
      .c-worklog-card {
        margin-top: 0.26rem;
      }
      .c-quick-access {
        margin-top: 0.26rem;
      }
    }
    .c-station-card {
      margin-top: 0.26rem;
    }
  }
  .p-welcome__body-background {
    position: fixed;
    top: 0;
    z-index: 9999;
    left: 0;
    right: 0;
    bottom: 0;
  }
  // 小链客服
  .p-my-product__root {
    position: fixed;
    right: 11px;
    top: 80%;
    transform: translateY(-50%);
    z-index: 5;
    .p-my-product__root__img {
      width: 79px;
    }
  }
  .p-my-product__root__body {
    display: none;
    position: absolute;
    right: 89px;
    top: 50%;
    transform: translateY(-50%);
    height: 180px;
    .p-my-product__root__code {
      position: relative;
      width: 180px;
      height: 180px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.17);
      img {
        position: relative;
        z-index: 3;
        width: 100%;
        height: 100%;
      }
    }
  }
  .p-my-product__root:hover .p-my-product__root__body {
    display: block;
  }
}
</style>
